import {colors} from 'asset/constant';

const toastIconAndColor = (type?: string): {icon: IconT; color: string} => {
  const {info, warning, danger, success} = colors;

  switch (type) {
    case 'success':
      return {
        icon: {name: 'checkcircleo', color: success},
        color: success,
      };

    case 'error':
      return {
        icon: {name: 'exclamationcircleo', color: danger},
        color: danger,
      };

    case 'warning':
      return {icon: {name: 'warning', color: warning}, color: warning};

    case 'info':
      return {icon: {name: 'infocirlceo', color: info}, color: info};

    default:
      return {icon: {name: 'infocirlceo', color: info}, color: info};
  }
};

export default toastIconAndColor;
